import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {DefaultLayoutComponent} from './layout/default-layout/default-layout.component';
import {ErrorComponent} from './layout/error/error.component';
import {UserRouteAccessService} from './security/user-route-access-service';
import {ROLE_ADMIN, ROLE_USER} from './constants';
import {PublicLayoutComponent} from 'app/layout/public-layout/public-layout.component';

/**
 *  Cada página pública debe tener su propio módulo lazy optimizado para conseguir el menos tamaño de
 *  build posible. En el caso de las páginas de administración o que necesitan que el usuario esté autenticado,
 *  podemos agruparlas por simplicidad ya que los tiempos de carga iniciales no son tan importantes.
 */
@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                {
                    path: '',
                    children: [
                        {
                            path: '',
                            loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
                            component: PublicLayoutComponent,
                        },
                        {
                            path: 'visor',
                            loadChildren: () => import('./public/visor/visor.module').then(m => m.VisorModule),
                        },
                        {
                            path: 'admin',
                            loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
                            data: {
                                authorities: [ROLE_ADMIN]
                            },
                            canActivateChild: [UserRouteAccessService],
                            component: DefaultLayoutComponent,
                        },
                        {
                            path: 'account',
                            loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
                            data: {
                                authorities: [ROLE_USER, ROLE_ADMIN]
                            },
                            canActivate: [UserRouteAccessService],
                            component: DefaultLayoutComponent,
                        },
                        {
                            path: 'auth',
                            loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
                            component: DefaultLayoutComponent,
                        },
                        {
                            path: '**',
                            component: PublicLayoutComponent,
                            children: [
                                {
                                    path: '**',
                                    component: ErrorComponent,
                                }
                            ]
                        }
                    ]
                },
            ],
            {
                useHash: false, enableTracing: false, onSameUrlNavigation: 'reload'
            }
        )
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
